import React, { Fragment } from "react";
import Form from "./components/Form";

function App() {
  return (
    <Fragment>
      <Form></Form>
    </Fragment>
  );
}

export default App;
